//A generic quiz component that feeds a set of questions to the specific quiz type, which is invoked as a subcomponent, keeps track of the session statistics and holds overall quiz state. This component accepts parameters that define the number of questions, mixture of questions, etc.
<template>
  <v-container fluid pa-0>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-space-around>
        <v-flex v-if="activeItems && !quizComplete">
          <v-progress-linear
            height="10"
            top
            v-model="progress"
          ></v-progress-linear>
          <v-btn small icon @click="toggleSound">
            <v-icon v-show="soundOn" color="black">volume_up</v-icon>
            <v-icon v-show="!soundOn" color="black">volume_off</v-icon>
          </v-btn>
          <component
            v-bind:is="currentQuestionComponent"
            v-bind:prompt="currentQuestion"
            v-on:check="handleAnswer"
            v-on:next="next"
            v-bind:controlled="true"
            :isLocked="true"
          ></component>
        </v-flex>
        <v-flex v-if="quizComplete">
          <v-flex xs12 sm6 offset-sm3>
            <v-card>
              <v-img :src="sheepImage" height="300px">
                <v-layout column fill-height></v-layout>
              </v-img>
            </v-card>

            <v-container text-xs-center>
              <div style="font-size: 40px; font-weight: bold; color: #3c5473">
                <span>Review Complete!</span>
              </div>
              <br />
              <br />
              <div style="font-size: 40px; font-weight: bold; color: #3c5473">
                <span>&nbsp;{{ correctPercent }}</span>
              </div>
              <div style="font-size: 17px; font-weight: bold; color: #3c5473">
                <span>Correct</span>
              </div>

              <v-card
                width="280px"
                height="60px"
                justify-center
                style="margin: auto; top: 35px"
                flat
              >
                <v-card-actions>
                  <v-btn large block round outline lg color="#3C5473" to="/"
                    >Return</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-container>
          </v-flex>

          <v-alert v-model="levelUp" dismissible type="success">
            Congratulations, you completed{{
              $store.state.user.currentLesson.title
            }}!
          </v-alert>

          <v-alert :value="!activeItems" type="error">
            There has been a problem retrieving your review queue. (T_T)
          </v-alert>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
import MultipleChoiceQuiz from "@/components/QuizTypes/MultipleChoiceQuiz";
import VocabTypedResponse from "@/components/QuizTypes/VocabTypedResponse";
import ParametersToConjugation from "@/components/QuizTypes/ParametersToConjugation";
import ConjugationToParameters from "@/components/QuizTypes/ConjugationToParameters";
import TranslationToConjugation from "@/components/QuizTypes/TranslationToConjugation";
import ConjugationToTranslation from "@/components/QuizTypes/ConjugationToTranslation";
import FridgeMagnet from "@/components/QuizTypes/FridgeMagnet";
import PaleographyQuestion from "@/components/QuizTypes/PaleographyQuestion";
import store from "../store/store.js";
export default {
  components: {
    VocabTypedResponse,
    FridgeMagnet,
    MultipleChoiceQuiz,
    ParametersToConjugation,
    ConjugationToParameters,
    TranslationToConjugation,
    ConjugationToTranslation,
    PaleographyQuestion,
  },
  props: {},
  data: function () {
    return {
      progress: 0,
      currentQuestionIndex: 0,
      quizComplete: false,
      sheepImage: require("@/../static/img/sheep_photo.jpg"),
      activeItems: _.shuffle(this.$store.getters.activeItems),
      quizResults: [],
      levelUp: false,
      componentMap: [
        { type: "fm", component: FridgeMagnet },
        { type: "vocab", component: VocabTypedResponse },
        {
          type: "parameters to conjugation",
          component: ParametersToConjugation,
        },
        {
          type: "conjugation to parameters",
          component: ConjugationToParameters,
        },
        {
          type: "translation to conjugation",
          component: TranslationToConjugation,
        },
        {
          type: "conjugation to translation",
          component: ConjugationToTranslation,
        },
        {
          type: "paleoquiz",
          component: PaleographyQuestion,
        },
      ],
      correctSFX: new Audio(require("../assets/correct.mp3")),
      wrongSFX: new Audio(require("../assets/wrong.wav")),
      soundOn: true,
    };
  },
  methods: {
    toggleSound: function () {
      this.soundOn = !this.soundOn;
    },
    handleAnswer: function (e) {
      this.quizResults.push(e.correct);
      if (e.correct) {
        this.markCorrect(this.currentQuestion);
        if (this.soundOn) {
          this.correctSFX.play();
        }
      } else if (this.soundOn) {
        this.wrongSFX.play();
      }
    },
    next: function () {
      if (this.currentQuestionIndex < this.activeItems.length - 1) {
        this.currentQuestionIndex++;
        this.progress =
          (this.currentQuestionIndex / this.activeItems.length) * 100;
      } else {
        this.handleComplete();
      }
    },
    handleComplete: function () {
      this.quizComplete = true;
      this.levelUp = this.checkLevelUp();
    },
    markCorrect: function (completedWord) {
      var wordTracker = this.$store.state.queue.find(
        (word) => word.id === completedWord.id
      );
      this.$store.dispatch("updateVocabQueue", wordTracker);
    },
    checkLevelUp: function () {
      if (this.$store.getters.willLevelUp) return true;
      else return false;
    },
  },
  computed: {
    correctPercent: function () {
      if (!this.$store.state.loading){
        var percent = (this.quizResults.filter((q) => q).length / this.activeItems.length) * 100
        var percentstring = percent + "%"
        return percentstring
      }
      else return 0;
    },
    currentQuestion: function () {
      return this.activeItems[this.currentQuestionIndex];
    },
    currentQuestionComponent: function () {
      return this.componentMap.find((x) => x.type === this.currentQuestionType)
        .component;
    },
    currentQuestionType: function () {
      return this.$store.state.queue.find(
        (x) => x.id === this.currentQuestion.id
      ).type;
    },
    level: function () {
      return this.$store.state.user.level;
    },
  },
  watch: {
    level(newLevel, oldLevel) {
      this.levelUp = true;
      console.log("You leveled up!!!");
    },
  },
};
</script>


<style>
.v-progress-linear {
  margin-top: 0;
}
</style>
